import { render } from "./Trame.vue?vue&type=template&id=5fee5446&scoped=true"
import script from "./Trame.vue?vue&type=script&lang=js"
export * from "./Trame.vue?vue&type=script&lang=js"

import "./Trame.vue?vue&type=style&index=0&id=5fee5446&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fee5446"]])

export default __exports__